import { apiCopilot4u } from '../api';

export async function answerGenerationAi(message) {
    const params = {
        mensagem: message.replace(/\s/g, "%20"),
        papel: "sou um(a) atendente de teleconsulta".replace(/\s/g, "%20"),
        empresa: `hospital de amor`.replace(/\s/g, "%20"),
        quantidade: 3
    }
    try {
        const { data } = await apiCopilot4u.post(`/AnswerGenerationAi?mensagem=${params.mensagem}&papel=${params.papel}&empresa=${params.empresa}&quantidade=${params.quantidade}`)
        return data;
    }
    catch (error) {
        return null;
    }
}